import styled from 'styled-components';

export const HeaderContainer = styled.div`
	width: 100%;
	max-width: 768px;
	height: 48px;

	position: relative;
	box-sizing: border-box;
	padding: 12px 40px;

	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${({ theme }) => theme['white-primary']};
`;

export const BackIconWrapper = styled.div`
	width: 24px;
	height: 24px;
	position: absolute;
	left: 20px;

	svg {
		width: 24px;
		height: 24px;
		cursor: pointer;

		path {
			fill: ${({ theme }) => theme['brown-primary']};
		}
	}
`;

export const Form = styled.form`
	width: 100%;
	padding: 20px;
	padding-bottom: calc(20px + 78px + 80px);

	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const FormItem = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 6px;
`;

export const Input = styled.input`
	width: 100%;
	padding: 12px;
	border-radius: 6px;
	border: none;

	background-color: ${({ theme }) => theme['warmgray-50']};
	color: ${({ theme }) => theme['font-secondary']};
	caret-color: ${({ theme }) => theme['orange-primary']};

	font-family: 'Pretendard';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;

	&::placeholder {
		color: ${({ theme }) => theme['font-tertiary']};
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		font-family: 'Pretendard';
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
		letter-spacing: 0.5px;
	}
`;

export const FolderList = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(90px, auto));
	gap: 10px;
`;

export const FolderItem = styled.label<{ isChecked: boolean }>`
	height: 36px;
	box-sizing: content-box;

	border-radius: 6px;
	/* border: 1px solid ${({ theme }) => theme['warmgray-300']}; */
	border: 1px solid rgba(210, 200, 195, 0.6);

	background-color: ${({ theme, isChecked }) =>
		isChecked ? theme['orange-secondary'] : theme.white};

	display: flex;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;

	input {
		display: none;
	}
`;

export const FolderListExpandButton = styled.button`
	width: 100%;
	padding: 2px 10px;

	display: flex;
	justify-content: center;
	align-items: center;
	gap: 6px;

	border: none;
	background-color: transparent;
	cursor: pointer;

	span {
		color: ${({ theme }) => theme['font-secondary']};
		font-family: 'Pretendard';
		font-size: 12px;
		font-style: normal;
		font-weight: 500;
		line-height: 19.412px;
	}
`;

export const TextArea = styled.textarea`
	width: 100%;
	height: 96px;
	padding: 12px;

	border: none;
	background-color: ${({ theme }) => theme['warmgray-50']};
	color: ${({ theme }) => theme['font-secondary']};
	caret-color: ${({ theme }) => theme['orange-primary']};

	font-family: 'Pretendard';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;

	resize: none;

	&::placeholder {
		color: ${({ theme }) => theme['font-tertiary']};
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		font-family: 'Pretendard';
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
		letter-spacing: 0.5px;
	}
`;

export const MemoLengthContainer = styled.div`
	width: 100%;

	display: flex;
	justify-content: flex-end;
	align-items: center;
`;

export const Footer = styled.div`
	width: 100%;
	padding: 10px 20px 16px 20px;
	bottom: 0px;
	margin-left: -20px;

	position: fixed;

	background-color: ${({ theme }) => theme['white-primary']};
`;
